import { useBooking } from "@/context/BookingContext";
import { IMAGES } from "@/lib/images";
import Reveal from "@/components/Reveal";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  const { openBooking } = useBooking();
  return (
    <section data-testid="final-cta" className="bg-white pt-8 pb-24 lg:pb-32">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10">
        <div className="relative overflow-hidden rounded-[2.5rem]">
          <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(${IMAGES.heroMacro})` }} />
          <div className="absolute inset-0 bg-[#1C1917]/85" />
          <div className="relative px-6 sm:px-16 py-24 lg:py-32 text-white">
            <Reveal>
              <div className="flex items-center gap-4 mb-7">
                <span className="w-10 h-px bg-[#C5B382]" />
                <span className="text-[#C5B382] text-[11px] tracking-[0.35em] uppercase font-semibold">Book Now</span>
              </div>
              <h2 className="font-serif text-6xl sm:text-8xl lg:text-9xl font-medium leading-[0.88] tracking-tight">
                Your next lash set<br /><span className="italic text-[#C5B382]">starts here.</span>
              </h2>
              <p className="mt-8 text-white/60 text-sm tracking-[0.18em] uppercase">
                Custom lashes · Personalised styling · Melbourne
              </p>
              <button
                data-testid="final-cta-book"
                onClick={() => openBooking()}
                className="group mt-9 inline-flex items-center gap-3 bg-[#C5B382] hover:bg-white text-[#1C1917] text-[11px] font-semibold tracking-[0.2em] uppercase px-10 py-5 rounded-full transition-colors duration-300"
              >
                Book Your Appointment
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
